import {
    OverlayScrollbars,
    ScrollbarsHidingPlugin,
    SizeObserverPlugin,
    ClickScrollPlugin
} from 'overlayscrollbars';

const scrollBarWrap = document.querySelector('.content__wrap');

if (scrollBarWrap){
    const osInstance = OverlayScrollbars(scrollBarWrap, {});
}